import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-transaction/page.tsx");
